import { analyticsFactory } from './factory'

const analyticsInstance = analyticsFactory()

export const getAnalyticsInstance = () => analyticsInstance
